import React, {Component} from 'react';

export default class AREntryTile extends Component {
  render() {
    const shareUrl = encodeURI(this.props.data.effectUrl);

    return (
      <div className="tile is-parent">
        <article className="tile is-child box">
          <p className="title is-size-5 has-text-left">{ this.props.data.location }</p>
          <p className="subtitle is-size-7 has-text-left">{ this.props.data.city }, { this.props.data.country }</p>
          <div className="content">
            <img src={ this.props.data.imageSrc ? `${ this.props.data.imageSrc }` : "/images/scene_placeholder.png"} className="App-sceneImage" />
            <p>
              { this.props.data.effectUrl ? <a href={`${ this.props.data.effectUrl }`} target="_blank" className="button tile-button-top">🤓 View AR Effect</a> : '🤓 View soon'}<br/>
              <a href={`${ this.props.data.locationUrl }`} target="_blank" className="button">📍 Map</a>
            </p>
            <p>
              <a href={`https://www.facebook.com/sharer.php?u=${ shareUrl }`} target="_blank"><img src={"/images/fb-share.png"} width="60px" height="20px" className="fb-share" /></a>
            </p>
            <p className="is-size-7">by <a href="">Enlive</a></p>
          </div>
        </article>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/arEntryTile.js